import { Link } from 'react-router-dom';
import './SignupThankYou.css';

export default function SignupThankYou() {
  return (
    <div className="signup-thanks">
      <div className="signup-thanks__card">
        <h1 className="signup-thanks__title">Welcome to ChicLogic.io 🎉</h1>
        <p className="signup-thanks__copy">
          Your account is ready. Check your inbox for a confirmation email, then sign in to start exploring hashtag insights and creator tools.
        </p>
        <div className="signup-thanks__actions">
          <Link to="/login" className="signup-thanks__button">Sign In</Link>
          <Link to="/hashtag-research" className="signup-thanks__link">Try the hashtag tool</Link>
        </div>
      </div>
    </div>
  );
}
